import styled from "styled-components";
import {
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
} from "../../../constants/Styles";

export const DashboardContainer = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  align-items: center;
`;

export const ManufacturingStatusContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column;
`;

export const BinInfoContainer = styled.div`
  flex: 2;
`;

export const StatusItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 0.5rem;
`;

export const Title = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size24};
  flex: 1;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 0.5rem;
  padding: 0.5rem;
  background-color: ${COLORS.badgeGray};
  cursor: grab;
`;

export const CalendarContainer = styled.div`
  min-width: 100%;

  .react-datepicker {
    width: 100%;
    max-width: 100vw;
  }

  .react-datepicker__day-name {
    flex: 1;
    text-align: center;
  }

  .react-datepicker__day {
    flex: 1;
    min-width: 0;
    display: flex;
  }
`;

const STATUS_COLORS: { [key: string]: string } = {
  shipped: "#32a852",
  late: "#cc3743",
  manufacturing: "#ffb805",
  loading: COLORS.disabled,
};

export const CalendarItemContainer = styled.div<{ status: string }>`
  background: ${({ status }) => STATUS_COLORS[status]};
  padding: 0.25rem;
  border-radius: 0.5rem;
  cursor: pointer;
  margin-bottom: 0.25rem;
  color: ${COLORS.black};
  font-weight: ${FONT_WEIGHT.weight500};
  font-size: ${FONT_SIZE.size13};
  display: flex;
  gap: 0.25rem;
  flex-direction: column;
  align-items: flex-start;
`;

export const CalendarItemTopRow = styled.div`
  width: 100%;
  display: flex;
  gap: 0.25rem;
`;

export const CalendarItemText = styled.div`
  min-width: 0;
`;

export const BoardIcon = styled.div`
  display: flex;
  align-items: center;
  > img {
    max-height: 2rem;
    max-width: 2rem;
  }
`;

export const ProjectName = styled.div`
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: ${FONT_SIZE.size18};
  font-family: ${FONTS.spaceGrotesk};
`;

export const Nickname = styled.div`
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: ${FONT_SIZE.size14};
  font-family: ${FONTS.spaceGrotesk};
`;

export const DateCell = styled.div<{ closure: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${COLORS.secondaryLight};
  padding: 0.5rem;
  background-color: ${({ closure }) => (closure ? COLORS.warn : "default")};
`;

export const DateHeader = styled.div`
  margin-bottom: 0.5rem;
  display: flex;
  gap: 1rem;
`;

export const ClosureDescription = styled.div`
  color: ${COLORS.secondaryLight};
`;

export const DayOfWeekHeader = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const ShipmentsList = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const NicknameContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
  gap: 0.5rem;
`;

interface PillColorScheme {
  background: string;
  text: string;
}

export type PillVariant = "neutral" | "ready" | "notReady";

export const PILL_COLOR_SCHEMES: Record<PillVariant, PillColorScheme> = {
  neutral: {
    background: COLORS.accent,
    text: COLORS.altSecondary,
  },
  ready: {
    background: COLORS.yes,
    text: COLORS.altSecondary,
  },
  notReady: {
    background: COLORS.no,
    text: COLORS.secondary,
  },
};

export const CalendarItemPill = styled.div<{ colorScheme: PillColorScheme }>`
  margin: 0.25rem 0;
  border-radius: 50px;
  padding: 0.125rem 0.5rem;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  font-size: ${FONT_SIZE.size12};
  font-weight: ${FONT_WEIGHT.weight700};
  ${({ colorScheme }) => `
      background: ${colorScheme.background};
      color: ${colorScheme.text};
  `}
`;

export const InventoryRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const CustomerSpecificationsRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const CustomerSpecifications = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const CustomerSpecification = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`;

export const SpecificationsIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-right: 0.5rem;
`;

export const SpecificationsNotes = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
`;
